import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import refresh from '@jd/jmtd-tools/es/refresh';
var sPaste = Symbol('paste');
var monitoringElements = new Set(); // 监控的元素

var monitoring; // 是否处于监控

export function MultipleInputContext(_ref) {
  var state = _ref.state;
  return {
    inputClassName: 'jmtd-multiple-input-input',
    checkPaste: function checkPaste() {
      var result = state[sPaste];
      delete state[sPaste];
      return result;
    },
    onUpdate: function onUpdate() {
      var ref = this.ref,
          focused = this.focused;
      var inputWrapper = ref.parentElement;
      inputWrapper.scrollLeft = focused ? inputWrapper.scrollWidth : 0;
      inputWrapper.scrollTop = 0;
      monitoringElements.add(inputWrapper);

      if (!monitoring) {
        // 轮询重置scrollTop为0，解决展开收起时scrollTop可能不为0导致tag错位的bug
        monitoring = refresh(function () {
          _toConsumableArray(monitoringElements).forEach(function (element) {
            // 判断元素是否在文档中，如果不在，解除监控
            if (document.documentElement.contains(element)) {
              if (element.scrollTop !== 0) {
                element.scrollTop = 0;
              }

              if (element.parentElement.scrollTop !== 0) {
                element.parentElement.scrollTop = 0;
              }
            } else {
              monitoringElements.delete(element); // 如果没有元素需要监控，移除监控
              // TAG错误检测
              // if (!monitoringElements.values().length) {
              //     monitoring.remove();
              //     monitoring = null;
              // }
            }
          });
        });
      }
    },
    onPaste: function onPaste() {
      state[sPaste] = true;
    }
  };
}